import React, { useEffect } from 'react';
import { Text } from 'react-native';

import Modal from 'react-native-modal';
import disableScroll from 'disable-scroll';
import AppStyles from '../../AppStyles';
import AppTheme from '../../AppTheme';
import TextStyle from '../../TextStyle';
import Colors from '../constants/AppColors';

const ToastModal = (props) => {

    useEffect(() => {
        if (props.showToast) {
            // disableScroll.on()
            var popUpTimer = setTimeout(() => {
                disableScroll.off();
                props.setToast({ showToast: false, text: '' });
                clearTimeout(popUpTimer);
            }, 4000);
        } else disableScroll.off()
    })

    return (
        <Modal backdropOpacity={0}
            onBackdropPress={() => {
                disableScroll.off();
                props.setToast({ showToast: false, text: '' })
            }}
            isVisible={props.showToast} hasBackdrop={true}
            deviceWidth={AppTheme.deviceWidth} deviceHeight={AppTheme.deviceHeight}
            style={[AppStyles.bottomFix, AppStyles.alignCenter,
            AppStyles.borderView, {
                margin: "auto", width: AppTheme.appWidth - 48,
                backgroundColor: Colors.grey.opaque,
                paddingVertical: 8, paddingHorizontal: 16,
                bottom: AppTheme.toastBottomMargin
            }]}>
            <Text style={[TextStyle.text12, {
                color: Colors.white, flexWrap: "wrap",
                textAlign: "center"
            }]}>{props.text}</Text>
        </Modal>
    )
}

export default ToastModal